import React from 'react';
import Seal from '../assets/print/seal_corporate.png';
import Seal2 from '../assets/print/seal_general.png';
import Logo from '../assets/print/logo_corporate.png';
import Logo2 from '../assets/print/logo_general.png';
import moment from 'moment';
import { Get as GetConfig } from '../view/basic/http';
import ImgConfirm from '../assets/images/print_confirm.png';

const day = ['일', '월', '화', '수', '목', '금', '토'];

class Bill extends React.Component {
    render() {
        const { data } = this.props;

        return (
            <div className="print_content">
                <div className="content">
                    <div className="table_list">
                        <table className="tbl_board_report">
                            <colgroup>
                                <col width="200" />
                                <col width="200" />
                                <col width="200" />
                                <col width="200" />
                                <col width="200" />
                                <col width="200" />
                                <col width="200" />
                            </colgroup>
                            <tr>
                                <td colSpan={5} style={{ fontSize: 30, fontWeight: 'bold' }}>
                                    분동운반인력 업무수행 교육일지
                                </td>
                                <td style={{ fontSize: 14, fontWeight: 'bold' }}>매달 10일 제출</td>
                            </tr>
                            <tr>
                                <td>교육주관</td>
                                <td>한국분동 주식회사</td>
                                <td>교육담당</td>
                                <td>
                                    최지원
                                    <img src={ImgConfirm} style={{ width: 30, height: 30, marginLeft: 6 }} />
                                </td>
                                <td>교육일자</td>
                                <td>{moment(data.report.createdAt).format('YYYY-MM-DD')}</td>
                            </tr>
                            <tr>
                                <td colSpan={4} style={{ fontSize: 26, fontWeight: 'bold' }}>
                                    업 무 수 행 교 육 내 용
                                </td>
                                <td>확인 (읽음)</td>
                                <td>교육대상자확인</td>
                            </tr>

                            <tr>
                                <td colSpan={4} className="content_left">
                                    검사일정을 확인한 후 분동운반을 위한 운반인력과 운반에 적합한 차량을 배차하여 분동운반 준비.
                                </td>
                                <td>O</td>
                                <td>배차지역</td>
                            </tr>

                            <tr>
                                <td colSpan={4} className="content_left">
                                    지정(약속)된 시간에 검사현장까지 필요로 하는 분동을 안전하게 운반.
                                </td>
                                <td>O</td>
                                <td rowSpan={5}>{data.branch.title}</td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="content_left">
                                    분동하역을 위한 안전장구를 착용 후 분동을 차량에서 안전하게 하역.
                                </td>
                                <td>O</td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="content_left">
                                    검사현장의 환경을 확인하여 안전사고 요인을 파악후 분동을 해당검사 호기로 안전하게 이동.
                                </td>
                                <td>O</td>
                            </tr>

                            <tr>
                                <td colSpan={4} className="content_left">
                                    카내 인터폰 혹은 무전기를 통해 진행사항을 검사원과 상시 통화하여 확인.
                                </td>
                                <td>O</td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="content_left">
                                    하중검사시 카내부에 "검사중" 임을 알리는 안내표지판을 설치한다.
                                </td>
                                <td>O</td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="content_left">
                                    오버밸런스율(50%) 검사시
                                    <br />- 정격하중의 50%를 적재 후 검사원의 지시에 따라 카내버튼으로 최상층 및 최하층을 카를 하강시킨다.
                                </td>
                                <td>O</td>
                                <td>성명</td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="content_left">
                                    125% 하중적재후 카의 미끄러짐 확인시
                                    <br />- 125% 적재시 카의 미끄러짐 발생, 운행시 기동불능 등 확인하고 이상현장 발생시 검사자에게 현장상황을 안내한다.
                                    <br />- 125% 적재후 최상층 도착확인하고 검사원의 지시에 따라 카를 하강후 비상정지 성능검사시 카의 미끄러짐 및 승강로 충돌 등
                                    이상상황 발생기 검사원에게 보고한다.
                                </td>
                                <td>O</td>
                                <td rowSpan={2}>{data.name}</td>
                            </tr>

                            <tr>
                                <td colSpan={4} className="content_left">
                                    과부하감지장치 검사확인 시<br />- 100%의 하중을 적재후 검사원(설치작업자)의 지시에 따라 분동을 카에 넣었다 빼면서
                                    설정완료시까지 대기한다.
                                </td>
                                <td>O</td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="content_left">
                                    검사원에게 하중검사 완료확인을 승낙 받은 후 다음검사대상 승강기로 이동하거나 차량으로 이동하여(상차) 복귀한다.
                                </td>
                                <td>O</td>
                                <td>확인(사인)</td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="content_left">
                                    하중검사 완료후 이동전 분동 및 이동대차의 분실 여부를 확인 한다.
                                </td>
                                <td>O</td>
                                <td rowSpan={2}>
                                    <img
                                        src={(data.report.sign || '').replace('http://kw24.co.kr:3000', 'https://api.kw24.co.kr')}
                                        style={{ width: 100, height: 50 }}
                                    />

                                </td>
                            </tr>
                            <tr>
                                <td className="content_left">교육목적</td>
                                <td colSpan={4} className="content_left">
                                    분동운반 작업자에 대한 업무수행교육을 통하여 분동업무에 대한 전문성을 강화하기 위함.
                                </td>
                            </tr>
                        </table>
                        {/* <div style={{ fontSize: 20, fontWeight: 'bold', textAlign: 'right', marginTop: 10 }}>사단법인 대한승강기 협회 귀중</div> */}
                    </div>
                </div>
            </div>
        );
    }
}

export default Bill;
